import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=7c35990d&scoped=true&"
import script from "./Solutions.vue?vue&type=script&lang=js&"
export * from "./Solutions.vue?vue&type=script&lang=js&"
import style0 from "./Solutions.vue?vue&type=style&index=0&id=7c35990d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35990d",
  null
  
)

export default component.exports